import { createAsyncThunk } from '@reduxjs/toolkit'
import { callErrorMsg } from 'helpers/errorMsg'
import { toastSuccess } from 'utils/toast'

import { getCustomerList, putKongStatusBuyer } from 'features/Account/services/buyer'
import { UpdateBuyerStatusPayloadType } from 'features/Account/@types/buyer'
import { setInitialCursorNext } from 'features/Account/redux/buyer/buyerSlice'

export const SLICE_NAME = 'buyer'

export const fetchBuyerList = createAsyncThunk(
  `${SLICE_NAME}/fetchBuyerList`,
  async (cursor: string, { rejectWithValue, getState, dispatch }) => {
    const {
      buyer: { query },
    } = getState() as StoreStateType

    try {
      const { data } = await getCustomerList({
        params: {
          page_index: -1,
          page_size: query.pageSize,
          search: query.name,
          sort: 'id',
          direction: 'desc',
          cursor,
        },
      })

      if (cursor === '') {
        dispatch(setInitialCursorNext(data.data.pagination.next_cursor))
      }

      return data
    } catch (error) {
      callErrorMsg(error)
      return rejectWithValue(error)
    }
  },
)

export const updateBuyerStatus = createAsyncThunk(
  `${SLICE_NAME}/updateBuyerStatus`,
  async (payload: UpdateBuyerStatusPayloadType, { rejectWithValue }) => {
    try {
      const { data } = await putKongStatusBuyer(payload)

      toastSuccess(`Berhasil merubah status customer `)

      return data
    } catch (error) {
      callErrorMsg(error)
      return rejectWithValue(error)
    }
  },
)
